import { useState } from 'react';

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

import { useRepresentative } from '../model';

const RemoveRepresentativeModal = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { action, representativeId, setInitialData, submit } = useRepresentative();

  const onProceed = async () => {
    setIsLoading(true);

    try {
      await submit?.remove(representativeId ?? '');
      setInitialData();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AlertDialog open={action === 'remove'} onOpenChange={setInitialData}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure you want to remove this representative?</AlertDialogTitle>
          <AlertDialogDescription>
            This person will no longer be listed as a point of contact in the escrow agreement.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={setInitialData}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onProceed} isLoading={isLoading}>
            Remove
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default RemoveRepresentativeModal;
